import { useContext, createElement } from 'react';
import { SystemContext } from './SystemContext.js';
import { a as _objectWithoutPropertiesLoose } from './_rollupPluginBabelHelpers-0f0865de.js';

function isRenderProp(children) {
  return typeof children === "function";
}

var useCreateElement = function useCreateElement(type, props, children) {
  if (children === void 0) {
    children = props.children;
  }

  var context = useContext(SystemContext);

  if (context.useCreateElement) {
    return context.useCreateElement(type, props, children);
  }

  if (isRenderProp(children)) {
    var _ = props.children,
        rest = _objectWithoutPropertiesLoose(props, ["children"]);

    return children(rest);
  }

  return createElement(type, props, children);
};

export { useCreateElement };
